import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody } from "@windmill/react-ui";
import { notifySuccess, notifyError } from "utils/toast";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const FeedbackSmsModal = ({
  isOpen,
  onClose,
  title = "Send Feedback to Customer",
  handleSubmit,
  selectedData,
  customClass = "",
}) => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [selectedSmsOption, setSelectedSmsOption] = useState(1);
  const [loading, setloading] = useState(false);

  const getAdminInfo = () => {
  return JSON.parse(localStorage.getItem("adminInfo")) || {};
};

  useEffect(() => {
    if (!isOpen) {
      setEmail("");
      setError("");
      setloading(false);
    }
    setEmail(selectedData);
  }, [isOpen, selectedData]);

  const handleSubmitSms = async () => {
    if (!email.trim()) {
      setError("Mobile Number is required!");
      return;
    }

    if (email.trim().length < 10) {
      setError("Mobile Number must be exactly 10 digits!");
      return;
    }

    const admin = getAdminInfo();
    const employeeId = admin.id;

    // setError("");
    var payload = {
      mobileno: email,
      type: selectedSmsOption,
      employee_id: employeeId,
    };
    // console.log("data to smsfeedback", payload);
    
    // handleSubmit(payload);
    setloading(true);
    try {
    const response = await handleSubmit(payload); 
    // console.log("response from api call ", response);
    
    notifySuccess(response?.message?.message || "Message sent successfully!");
    onClose(); 
  } catch (err) {
    // console.log("error----", err);
    
    notifyError(err?.response?.data?.message ||
      err?.message || "Failed to send message. Please try again.");
  } finally {
    setloading(false);
  }
  };

  const handleSmsChange = (e) => {
    setSelectedSmsOption(e.target.value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`relative bg-white dark:bg-gray-700 pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
      aria-labelledby="modal-title"
    >
      <CommonCloseBtn
      onClose={onClose}
      />
      <span id="modal-title" className="flex text-xl text-green-500">
        {title}
      </span>
      <ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
        <div className="radio-input-wrapper flex gap-5 items-center space-x-4">
          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              id="1"
              className="radio-type"
              value={1}
              checked={Number(selectedSmsOption) === 1}
              onChange={handleSmsChange}
            />
            <span className="ms-3">SMS</span>
          </label>
          <label className="label pe-md-3 py-1 py-sm-2">
            <input
              type="radio"
              id="2"
              className="radio-type"
              value={2}
              required
              //checked={selectedSmsOption == 2}
              checked={Number(selectedSmsOption) === 2}
              onChange={handleSmsChange}
            />
            <span className="ms-3">Whatsapp</span>
          </label>
        </div>
        <input
          className="w-full border border-gray-300 dark:border-gray-600 dark:bg-transparent rounded p-2 mt-8"
          placeholder="Enter Mobile Number"
          value={email}
          autoComplete="off"
          type="number"
          maxLength={10}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
            if (value.length <= 10) {
              setEmail(value);
            }
          }}
          style={{ height: "100%" }}
        />
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        <div className="flex items-center justify-around gap-4 mt-8">
          <Button
            disabled={loading}
            onClick={handleSubmitSms}
            className="bg-green-500 hover:bg-green-600 text-white w-full sm:w-auto"
          >
            Send
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default FeedbackSmsModal;
